"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JVMBlockchain = void 0;
const utils_1 = require("../utils");
const chain_1 = require("./chain");
const constants_1 = require("./constants");
const vm_1 = require("./vm");
class JVMBlockchain extends chain_1.AbstractBlockchain {
    constructor(name, id, asset, aliases, registeredAssets = []) {
        super(name, id, new vm_1.ChainVM(constants_1.JVM_ID, vm_1.VMType.JVM, vm_1.VMWalletType.Utxo, constants_1.JVM_HD_PATH), asset, aliases, registeredAssets);
    }
    async fetchAsset(provider, assetId) {
        return await (0, utils_1.fetchJNT)(provider, assetId);
    }
    validateAddress(address, hrp) {
        return (0, utils_1.validateBech32)(address, hrp, this.aliases.concat(this.id));
    }
}
exports.JVMBlockchain = JVMBlockchain;
